import { queryOptions } from "@tanstack/react-query"
import axios from "axios"
import { DataResponse, ReveniIntegrationResponseDataSchema } from "schema"
import { z } from "zod"

type Response = DataResponse<z.infer<typeof ReveniIntegrationResponseDataSchema>>

const queryKey = ["reveniIntegration"]

export const reveniIntegrationQuery = () => {
  return queryOptions({
    queryKey,
    queryFn: async () => {
      const response = await axios.get<Response>(`/integrations/reveni/configuration`)

      return response.data.data
    },
  })
}
